var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page-section',{staticClass:"w-100",attrs:{"title":"Lista linee di servizio","backLink":true}},[_c('services-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }